import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { ProfileAvatar } from '@app/components/blocks/avatarStack/AvatarStack'
import { MunicipalityCard } from '@app/components/blocks/card/MunicipalityCard'
import { SearchGrid } from '@app/components/blocks/searchGrid/SearchGrid'
import { Style } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'

type MunicipalitySearchGridItem = {
  id: number
  slug: string
  avatar?: string
  title: string
  description?: string
  hasBadge?: boolean
  isLocked?: boolean
  plots?: number
  initiatives: number
  avatars: ProfileAvatar[]
}

export type MunicipalitySearchGridProps = {
  items: MunicipalitySearchGridItem[]
  totalItems: number
  title: string
  subtitle: string
  searchTerm?: string
  isLoading: boolean
  moreToLoad: boolean
  loadMore: () => void
  onResetSearch: () => void
}

export const MunicipalitySearchGrid = (props: MunicipalitySearchGridProps) => {
  const [_location, navigate] = useLocation()
  const isMobile = useMediaQuery()

  const gridStyle: Style = isMobile
    ? {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }
    : {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(14rem, 1fr))',
        '@media (max-width: 1400px)': {
          gridTemplateColumns: 'repeat(4, minmax(14rem, 1fr))',
        },
        '@media (max-width: 1200px)': {
          gridTemplateColumns: 'repeat(3, minmax(14rem, 1fr))',
        },
        gap: '1rem',
      }

  return (
    <SearchGrid
      {...props}
      items={props.items.map((i) =>
        renderCard(i, () => navigate(pages.municipalityPage(i.slug))),
      )}
      gridStyle={gridStyle}
    />
  )
}

const renderCard = (
  item: MunicipalitySearchGridItem,
  onClick: VoidFunction,
) => {
  return <MunicipalityCard key={item.slug} onClick={onClick} {...item} />
}
